import {FC, ReactNode} from "react";
import {Helmet} from "react-helmet";
import {useTranslation} from "react-i18next";

interface IProps {
    children: ReactNode;
}

const HelmetWrapper: FC<IProps> = ({children}) => {
    const {t} = useTranslation()

    const keywords = t('app_keywords')

    const jsonLd = {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "Genie",
        "url": "https://genie.mk",
        "logo": "https://cdn.genie.mk/assets/logo-purple.png",
        "description": t('app_jsonld_description'),
        "department": {
            "@type": "Service",
            "serviceType": "Online Raffle",
            "category": "Entertainment",
            "keywords": keywords.split(", ")
        }
    }

    return (
        <>
            <Helmet>
                <meta
                    name="description"
                    content={t('app_description')}
                />
                <meta
                    name="keywords"
                    content={keywords}
                />

                <script type="application/ld+json">
                    {JSON.stringify(jsonLd)}
                </script>
            </Helmet>
            {children}
        </>

    )
}

export default HelmetWrapper